import { setShowAccessPassPopup } from "basket_and_checkout/shared/components/PDP/Pricing/utils"
import cookie from "js-cookie"
import { addBasketItemsWithSpinner } from "lib/api"
import type { BasketItem } from "lib/api/addBasketItems"
import type { User } from "lib/apollo/types"
import { getLocale } from "lib/apolloClient"
import { dispatch, subscribe } from "lib/events"
import { getUser } from "lib/user"
import type { BasketUpdateResultType } from "types"

export enum YCSSPreference {
  WITHOUT_MEMBERSHIP = "0",
  WITH_MEMBERSHIP = "1",
}

type YCSSCloseEventDetail = {
  preference: YCSSPreference
}

const KEY = "ycss.preference"

const setPreference = (preference: YCSSPreference): YCSSPreference => {
  cookie.set(KEY, preference)
  return preference
}

const getPreference = (): YCSSPreference | undefined => {
  const cookieValue = cookie.get(KEY)

  if (
    cookieValue === YCSSPreference.WITH_MEMBERSHIP ||
    cookieValue === YCSSPreference.WITHOUT_MEMBERSHIP
  ) {
    return cookieValue
  }
}

export const shouldPrompt = (
  locale: string,
  user: User,
  isProductFirst: boolean,
  preferenceCookieValue?: string
) => {
  if (locale !== "en-GB" || isProductFirst) {
    setShowAccessPassPopup("1")
    return false
  }

  return (
    !user?.basketCount &&
    !user?.hasMembership &&
    preferenceCookieValue === undefined
  )
}

export type AddToBagWithYCSSPrompt = (
  params: Parameters<typeof addBasketItemsWithSpinner>,
  membershipOffered: BasketItem,
  isProductFirst: boolean
) => Promise<BasketUpdateResultType>

export const addToBagWithYCSSPrompt: AddToBagWithYCSSPrompt = async (
  params,
  membershipOffered,
  isProductFirst
) => {
  const user = getUser()
  const locale = getLocale()

  if (shouldPrompt(locale, user, isProductFirst, getPreference())) {
    dispatch("ycss.open", {})

    const { preference }: YCSSCloseEventDetail = await new Promise((resolve) =>
      subscribe("ycss.preference", resolve)
    )

    setPreference(preference)

    if (preference === YCSSPreference.WITH_MEMBERSHIP) {
      const [items] = params
      items.push(membershipOffered)
      params.push({ explicitUserMembershipAdd: true })
    }
    setShowAccessPassPopup("1")
  }

  return addBasketItemsWithSpinner(...params)
}
